export * from "ce/hooks/useSSHKeyManager";
export type { UseSSHKeyManagerReturn } from "ce/hooks/useSSHKeyManager";

import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFeatureFlag } from "utils/hooks/useFeatureFlag";
import { FEATURE_FLAG } from "ee/entities/FeatureFlag";
import { fetchSSHKeysInit } from "ee/actions/sshKeysActions";
import {
  selectSSHKeysList,
  selectSSHKeysLoading,
} from "ee/selectors/sshKeysSelectors";
import { adminSettingsCategoryUrl } from "ee/RouteBuilder";
import { SettingCategories } from "ee/pages/AdminSettings/config/types";
import history from "utils/history";
import type { UseSSHKeyManagerReturn } from "ce/hooks/useSSHKeyManager";

export default function useSSHKeyManager(): UseSSHKeyManagerReturn {
  const dispatch = useDispatch();

  const isSSHKeyManagerEnabled = useFeatureFlag(
    FEATURE_FLAG.release_ssh_key_manager_enabled,
  );
  const sshKeys = useSelector(selectSSHKeysList);
  const isSSHKeysLoading = useSelector(selectSSHKeysLoading);

  const fetchSSHKeys = useCallback(() => {
    dispatch(fetchSSHKeysInit());
  }, [dispatch]);

  const onCreateSSHKey = useCallback(() => {
    history.push(
      adminSettingsCategoryUrl({ category: SettingCategories.SSH_KEYS }),
    );
  }, []);

  return {
    isSSHKeyManagerEnabled,
    sshKeys,
    isSSHKeysLoading,
    fetchSSHKeys,
    onCreateSSHKey,
  };
}
